<template>
  <div id="auth-container">
      <v-dialog/>
      <router-view/>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {

  },
  components: {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>
